"use strict";
import {GlobalParameters} from "generated"
import i18next from "i18next";
import { translations } from "./translations/translations";

export class TranslateService{
    constructor(){
        this.initTranslate()
    }
    initTranslate() {
        i18next.init(
            {
                fallbackLng: { 
                    'default': ['ru']
                },
                lng: GlobalParameters.globals.Language,
                debug: true,
                enableSelector: true,
                resources: translations,
            },
        );
    }
}